import {
  CheckOutlined,
  DatabaseOutlined,
  DollarOutlined,
  FilterOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Button, DatePicker, Input, message, Table } from "antd";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import moment from "moment";
import "./purchaseHistory.css";
import PurchaseHistoryModal from "../../../components/purchaseHistoryModal/PurchaseHistoryModal";
import { axiosInstance } from "../../../utils/axiosInterceptor";
const PurchaseHistory = ({
  PurchaseHistory,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  getPurchaseHIstory,
  filterLoading,
  current,
  pageSize,
  total,
  onPageChange,
  accountNo,
  // supplierId,
  userId
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedOrderNo, setSelectedOrderNo] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSizeOrder, setPageSizeOrder] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [orderDetails, setOrderDetails] = useState([]);
  const [orderStatus, setorderstatus] = useState("");
  const [orderDate, setOrderDate] = useState("");

  const getOrderDetails = async (record) => {
    // if(!supplierId || !accountNo || !userId){
    //   return;
    // }
    const orderId = record?.OrderNumber || selectedOrderNo;
    if (!orderId) return;
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `api/marketplace/order-lines-items/${orderId}?page=${currentPage}&limit=${pageSizeOrder}`,
        // {
        //   headers : {
        //     "x-api-key" : "01486e2946f424268dbcf835b976130f09485eddfbb9fbeaa9b9607bc737d0d4"
        //   }
        // }
      );
      if (response?.data?.data?.data) {
        setOrderDetails(response?.data?.data);
      } else {
        setOrderDetails([]);
      }
      setTotalRecords(response?.data?.data?.paginationpagination?.totalRecords);
      setCurrentPage(response?.data?.data?.pagination?.currentPage);
      setPageSizeOrder(response?.data?.data?.pagination?.pageSize);
    } catch (error) {
      console.log(error, "Errror");
    } finally {
      setLoading(false);
    }
  };
  const columns = [
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
      align: "center",
      render: (text) => moment(text).format("MM-DD-YYYY"),
      sorter: (a, b) => String(a.Date).localeCompare(String(b.Date)),
    },
    {
      title: "Supplier",
      dataIndex: "supplier",
      key: "supplier",
      align: "center",
      render: (sup) => sup || "-",
    },
    {
      title: "Order Number",
      dataIndex: "OrderNumber",
      key: "OrderNumber",
      align: "center",
      render: (val) =>
        val ? (
          <div>
            <span>{val || "-"}</span>
            {/* <EyeOutlined color="#888" onClick={()=>navigate('/product-details')}/> */}
          </div>
        ) : (
          <span>-</span>
        ),
      sorter: (a, b) =>
        String(a.OrderNumber).localeCompare(String(b.OrderNumber)),
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      align: "center",
      render: (v) => {
        if (v === "ORDER_SENT") {
          return "ORDER SENT";
        } else if (v === "ACK_RECEIVED") {
          return "ACK RECEIVED";
        } else return v;
      },
    },
    // {
    //   title: "Total Quantity",
    //   dataIndex: "total_quantity",
    //   key: "total_quantity",
    //   align: "right",
    //   render: (total) => total || "-",
    //   sorter: (a, b) => a?.TotalPrice - b?.TotalPrice,
    // },
    // {
    //   title: "Total Price",
    //   dataIndex: "TotalPrice",
    //   key: "TotalPrice",
    //   align: "right",
    //   render: (total) => `$ ${total.toFixed(2)}` || "-",
    //   sorter: (a, b) => a?.TotalPrice - b?.TotalPrice,
    // },
    // {
    //   title: "Total Amount",
    //   children: [
    //     {
    //       title: "Ordered",
    //       dataIndex: "TotalPrice",
    //       key: "TotalPrice",
    //       align: "right",
    //       sorter: true,
    //       sorter: (a, b) =>
    //         parseFloat(a.TotalPrice || 0) -
    //         parseFloat(b.TotalPrice || 0),
    //       render: (total) =>
    //         total !== null && total !== undefined
    //           ? `$ ${total?.toFixed(2)}`
    //           : "-",
    //     },
    //     // {
    //     //   title: "Shipment Amount",
    //     //   dataIndex: "total_shipped_price",
    //     //   key: "total_shipped_price",
    //     //   align: "right",
    //     //   sorter: true,
    //     //   sorter: (a, b) =>
    //     //     parseFloat(a.total_shipped_price || 0) -
    //     //     parseFloat(b.total_shipped_price || 0),
    //     //   render: (total) =>
    //     //     total !== null && total !== undefined
    //     //       ? `$ ${total?.toFixed(2)}`
    //     //       : "-",
    //     // },
    //     {
    //       title: "Invoiced",
    //       dataIndex: "total_invoiced_price",
    //       key: "total_invoiced_price",
    //       align: "right",
    //       sorter: true,
    //       sorter: (a, b) =>
    //         parseFloat(a.total_invoiced_price || 0) -
    //         parseFloat(b.total_invoiced_price || 0),
    //       render: (total) =>
    //         total !== null && total !== undefined
    //           ? `$ ${total?.toFixed(2)}`
    //           : "-",
    //     },
    //   ],
    // },
    {
      title: "Total Amount Ordered",
      dataIndex: "TotalPrice",
      key: "TotalPrice",
      align: "right",
      sorter: true,
      sorter: (a, b) =>
        parseFloat(a.TotalPrice || 0) - parseFloat(b.TotalPrice || 0),
      render: (total) =>
        total !== null && total !== undefined
          ? `$ ${Number(total || 0).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          : "-",
    },
    {
      title: "Total Amount Invoiced",
      dataIndex: "total_invoiced_price",
      key: "total_invoiced_price",
      align: "right",
      sorter: true,
      sorter: (a, b) =>
        parseFloat(a.total_invoiced_price || 0) -
        parseFloat(b.total_invoiced_price || 0),
      render: (total) =>
        total !== null && total !== undefined
          ? `$ ${Number(total || 0).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          : "-",
    },
    // {
    //   title: "Quantity",
    //   children: [
    //     {
    //       title: "Ack Quantity",
    //       dataIndex: "total_acknowledged_qty",
    //       key: "total_acknowledged_qty",
    //       align: "right",
    //       render: (val) => (val !== null && val !== undefined ? val : "-"),
    //       sorter: true,
    //       sorter: (a, b) =>
    //         parseFloat(a.total_acknowledged_qty || 0) -
    //         parseFloat(b.total_acknowledged_qty || 0),
    //     },
    //     {
    //       title: "Shipment Quantity",
    //       dataIndex: "total_shipped_qty",
    //       key: "total_shipped_qty",
    //       align: "right",
    //       render: (val) => (val !== null && val !== undefined ? val : "-"),
    //       sorter: true,
    //       sorter: (a, b) =>
    //         parseFloat(a.total_shipped_qty || 0) -
    //         parseFloat(b.total_shipped_qty || 0),
    //     },
    //     {
    //       title: "Invoice Quantity",
    //       dataIndex: "total_invoiced_qty",
    //       key: "total_invoiced_qty",
    //       align: "right",
    //       render: (val) => (val !== null && val !== undefined ? val : "-"),
    //       sorter: true,
    //       sorter: (a, b) =>
    //         parseFloat(a.total_invoiced_qty || 0) -
    //         parseFloat(b.total_invoiced_qty || 0),
    //     },
    //   ],
    // },

    {
      title: "Details",
      key: "action",
      align: "center",
      render: (text, record) => {
        return (
          <div className="flex items-center justify-center gap-2">
            <Button
              onClick={() => {
                setSelectedOrderNo(record?.OrderNumber);
                setorderstatus(record?.Status);
                setModalVisible(true);
                setOrderDate(record?.Date);
                getOrderDetails(record);
              }}
            >
              View
            </Button>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    getOrderDetails();
  }, [pageSizeOrder, currentPage]);

  return (
    <div>
      <div className="p-3 px-6 font-sans">
        <div className="flex flex-col gap-3 ">
          <div className="flex flex-col md:flex-row md:justify-between items-center gap-y-8 sm:flex-wrap gap-4 w-full md:w-auto mb-10">
            <h1 className="text-3xl font-bold text-center text-[#040b35]">
              Purchase History
            </h1>
            <div className="flex flex-col sm:flex-row flex-wrap items-start sm:items-center gap-3 w-full lg:w-auto">
              <div className="flex gap-4">
                <div className="flex flex-row sm:flex-row items-start sm:items-center gap-2">
                  <span className="font-medium text-gray-600">From</span>
                  <DatePicker
                    value={fromDate ? dayjs(fromDate) : null}
                    format="MM-DD-YYYY"
                    className="w-full sm:w-[220px]"
                    placeholder="Select Start Date"
                    onChange={(date) => {
                      if (date) {
                        const formattedDate = date.format("MM-DD-YYYY");
                        setFromDate(formattedDate);
                      } else {
                        setFromDate(null);
                      }
                    }}
                  />
                </div>

                <div className="flex flex-row sm:flex-row items-start sm:items-center gap-2">
                  <span className="font-medium text-gray-600">To</span>
                  <DatePicker
                    value={toDate ? dayjs(toDate) : null}
                    format="MM-DD-YYYY"
                    className="w-full sm:w-[220px]"
                    placeholder="Select End Date"
                    onChange={(date) => {
                      if (date) {
                        const formattedDate = date.format("MM-DD-YYYY");
                        setToDate(formattedDate);
                      } else {
                        setToDate(null);
                      }
                    }}
                  />
                </div>
              </div>

              <Button
                // type="primary"
                className="w-full sm:w-auto px-6 !bg-[#001997] hover:!bg-[#061561] text-white border-none hover:!text-white"
                icon={<FilterOutlined />}
                onClick={() => {
                  if (fromDate && toDate) {
                    getPurchaseHIstory(1, 10, fromDate, toDate);
                  } else {
                    message.error("Please Select Valid Date");
                  }
                }}
              >
                Filter
              </Button>
            </div>
          </div>
          {/* <h1 className="text-3xl font-bold text-center text-[#040b35]">
            AdvantEdge Catalog
          </h1> */}

          {/* <div className="flex  gap-6  overflow-x-auto md:overflow-visible  w-full md:w-auto  scrollbar-hide">
              <div className="w-[280px] flex-shrink-0 ">
                <div className="bg-white rounded-lg p-4 border border-gray-200 space-y-2">
                  <div className="flex justify-between items-center">
                    <p className="text-[20px] text-[#040b35] font-bold">
                      Total Orders :
                    </p>
                    <p className="text-[20px] text-[#040b35] font-bold">
                      {PurchaseHistory?.supplier_summary?.total_orders || "-"}
                    </p>
                  </div>

                  <div className="flex justify-between items-center">
                    <p className="text-sm text-gray-600">IPC :</p>
                    <p className="text-sm text-gray-700 font-medium">
                      {PurchaseHistory?.supplier_summary?.IPC || "-"}
                    </p>
                  </div>

                  <div className="flex justify-between items-center">
                    <p className="text-sm text-gray-600">Masters :</p>
                    <p className="text-sm text-gray-700 font-medium">
                      {PurchaseHistory?.supplier_summary?.Masters || "-"}
                    </p>
                  </div>

                  <div className="flex justify-between items-center">
                    <p className="text-sm text-gray-600">McKesson :</p>
                    <p className="text-sm text-gray-700 font-medium">
                      {PurchaseHistory?.supplier_summary?.McKesson || "-"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-[280px] flex-shrink-0 ">
                <div className="bg-white rounded-lg p-4 border border-gray-200 space-y-2">
                  <div className="flex justify-between items-center">
                    <p className="text-[20px] text-[#040b35] font-bold">
                      Total NDC :
                    </p>
                    <p className="text-[20px] text-[#040b35] font-bold">
                      {"-"}
                    </p>
                  </div>

                  <div className="flex justify-between items-center">
                    <p className="text-sm text-gray-600">IPC :</p>
                    <p className="text-sm text-gray-700 font-medium">{"-"}</p>
                  </div>

                  <div className="flex justify-between items-center">
                    <p className="text-sm text-gray-600">Masters :</p>
                    <p className="text-sm text-gray-700 font-medium">{"-"}</p>
                  </div>

                  <div className="flex justify-between items-center">
                    <p className="text-sm text-gray-600">McKesson :</p>
                    <p className="text-sm text-gray-700 font-medium">{"-"}</p>
                  </div>
                </div>
              </div>
              <div className="w-[280px] flex-shrink-0 ">
                <div className="bg-white rounded-lg p-4 border border-gray-200 space-y-2">
                  <div className="flex justify-between items-center">
                    <p className="text-[20px] text-[#040b35] font-bold">
                      Total Amount :
                    </p>
                    <p className="text-[20px] text-[#040b35] font-bold">
                      {"-"}
                    </p>
                  </div>

                  <div className="flex justify-between items-center">
                    <p className="text-sm text-gray-600">IPC :</p>
                    <p className="text-sm text-gray-700 font-medium">{"-"}</p>
                  </div>

                  <div className="flex justify-between items-center">
                    <p className="text-sm text-gray-600">Masters :</p>
                    <p className="text-sm text-gray-700 font-medium">{"-"}</p>
                  </div>

                  <div className="flex justify-between items-center">
                    <p className="text-sm text-gray-600">McKesson :</p>
                    <p className="text-sm text-gray-700 font-medium">{"-"}</p>
                  </div>
                </div>
              </div>
            </div> */}

          <div className="flex gap-6 overflow-x-auto  w-full scrollbar-hide">
            <div className="min-w-[320px] bg-white rounded-xl p-5 shadow-sm border border-gray-100 flex justify-between items-start">
              <div>
                <p className="text-[18px] text-gray-500 font-medium">
                  Total Orders
                </p>

                <h2 className="text-2xl font-bold text-[#040b35] mt-2">
                  {PurchaseHistory?.supplier_summary?.total_orders || "-"}
                </h2>

                <p className="text-[15px] text-gray-500 mt-1">
                  IPC: {PurchaseHistory?.supplier_summary?.IPC || "-"}
                </p>
                <p className="text-[15px] text-gray-500 mt-1">
                  Masters: {PurchaseHistory?.supplier_summary?.Masters || "-"}
                </p>
                <p className="text-[15px] text-gray-500 mt-1">
                  McKesson: {PurchaseHistory?.supplier_summary?.McKesson || "-"}
                </p>
              </div>

              {/* ICON */}
              {/* <div className="bg-green-100 text-green-600 p-2 rounded-lg">
      ✔
    </div> */}
              <div className="w-8 h-8 bg-green-100 rounded-xl flex items-center justify-center">
                <CheckOutlined className="text-green-600 text-lg font-bold" />
              </div>
            </div>

            <div className="min-w-[320px] bg-white rounded-xl p-5 shadow-sm border border-gray-100 flex justify-between items-start">
              <div>
                <p className="text-[18px] text-gray-500 font-medium">
                  Total NDC
                </p>

                <h2 className="text-2xl font-bold text-[#040b35] mt-2">
                  {PurchaseHistory?.ndc_summary?.total_ncd || "-"}
                </h2>
                <p className="text-[15px] text-gray-500 mt-1">
                  IPC: {PurchaseHistory?.ndc_summary?.IPC || "-"}
                </p>
                <p className="text-[15px] text-gray-500 mt-1">
                  Masters: {PurchaseHistory?.ndc_summary?.Masters || "-"}
                </p>
                <p className="text-[15px] text-gray-500 mt-1">
                  McKesson: {PurchaseHistory?.ndc_summary?.McKesson || "-"}
                </p>
              </div>

              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                <DatabaseOutlined className="text-blue-600 text-lg" />
              </div>
              {/* <div className="bg-red-100 text-red-500 p-2 rounded-lg">
      ⏱
    </div> */}
            </div>

            <div className="min-w-[320px] bg-white rounded-xl p-5 shadow-sm border border-gray-100 flex justify-between items-start">
              <div>
                <p className="text-[18px]  text-gray-500 font-medium">
                  Total Amount
                </p>

                <h2 className="text-2xl font-bold text-[#040b35] mt-2">
                  {PurchaseHistory?.amount_summary?.total_amount ? `$ ${PurchaseHistory?.amount_summary?.total_amount?.toFixed(2)}` : "-"}
                  {/* {`$ ${PurchaseHistory?.amount_summary?.total_amount?.toFixed(2)}` ??
                    "-"} */}
                </h2>
                <p className="text-[15px] text-gray-500 mt-1">
                  IPC:{" "}
                  {PurchaseHistory?.amount_summary?.IPC ? `$ ${PurchaseHistory?.amount_summary?.IPC?.toFixed(2)}` : "-"}
                  {/* {`$ ${PurchaseHistory?.amount_summary?.IPC?.toFixed(2)}` ??
                    "-"} */}
                </p>
                <p className="text-[15px] text-gray-500 mt-1">
                  Masters:{" "}
                  {PurchaseHistory?.amount_summary?.Masters ? `$ ${PurchaseHistory?.amount_summary?.Masters?.toFixed(2)}` :
                    "-"}
                  {/* {`$ ${PurchaseHistory?.amount_summary?.Masters?.toFixed(2)}` ??
                    "-"} */}
                </p>
                <p className="text-[15px] text-gray-500 mt-1">
                  McKesson:{" "}
                  {PurchaseHistory?.amount_summary?.McKesson ? `$ ${PurchaseHistory?.amount_summary?.McKesson?.toFixed(2)}` : "-"}
                  {/* {`$ ${PurchaseHistory?.amount_summary?.McKesson?.toFixed(2)}` ??
                    "-"} */}
                </p>
              </div>
              <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                <DollarOutlined className="text-green-600 text-lg" />
              </div>
              {/* <div className="bg-blue-100 text-blue-600 p-2 rounded-lg">
      💳
    </div> */}
            </div>
          </div>
        </div>
        {/* <Table
          columns={NewColumn}
          dataSource={PurchaseHistory}
          rowKey="product_code"
          scroll={{ x: "max-content" }}
          className="custom-table user-tbl"
          pagination={{
            pageSize: pagination,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} accounts`,
            onShowSizeChange: (current, size) => {
              setPagination(size);
            },
          }}
        /> */}
        <Table
          columns={columns}
          dataSource={PurchaseHistory?.data}
          loading={filterLoading}
          rowKey="product_code"
          scroll={{ x: "max-content" }}
          // scroll={{ x: 500, y:500}}
          // className="custom-table user-tbl"
          className="custom-table user-tbl"
          pagination={{
            current,
            total,
            showSizeChanger: true,
            pageSize,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
          }}
          onChange={(pagination) =>
            onPageChange(pagination.current, pagination.pageSize)
          }
        />
      </div>
      <PurchaseHistoryModal
        open={modalVisible}
        hide={() => setModalVisible(false)}
        orderDetails={orderDetails}
        OrderNumber={selectedOrderNo}
        current={currentPage}
        pageSize={pageSizeOrder}
        total={totalRecords}
        onPageChange={(page, size) => {
          setCurrentPage(page);
          setPageSizeOrder(size);
        }}
        loading={loading}
        orderStatus={orderStatus}
        orderDate={orderDate}
        accountNo = {accountNo}
        // supplierId = {supplierId}
        userId = {userId}
      />
    </div>
  );
};

export default PurchaseHistory;